// import React, { Component, useState, useEffect } from "react";
import React, { Component, useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import { Redirect, useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useRef } from "react";
import styled from "styled-components";
import apiConfig from '../apiConfig'; 


const PromoCodeList = () => {
  const [data, setData] = useState([]);
  const [limit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [summary, setSummary] = useState({ totalRebateGiven: 0, totalBetAmount: 0, totalUser: 0 });

  // ✅ Filter states
  const [range, setRange] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [username, setUsername] = useState("");

  const currentPage = useRef(1);

  useEffect(() => {
    currentPage.current = 1;
    getPaginatedUsers();
  }, [range, sortBy, sortOrder]);

  function handlePageClick(e) {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  }

  function getPaginatedUsers() {
    const params = new URLSearchParams({
      page: currentPage.current,
      limit,
      range,
      sortBy,
      sortOrder,
      ...(username && { username }),
      ...(range === "custom" && startDate && { startDate }),
      ...(range === "custom" && endDate && { endDate }),
    });

    fetch(`${apiConfig.baseURL}/api/admin/RebateCommissionReport?${params}`)
      .then((res) => res.json())
      .then((data) => {
        setPageCount(data.pageCount);
        setSummary({
          totalRebateGiven: data.totalRebateGiven,
          totalBetAmount: data.totalBetAmount,
          totalUser: data.totalUser
        });
        setData(data.result);
      });
  }

  function handleSearch() {
    currentPage.current = 1;
    getPaginatedUsers();
  }

  function handleReset() {
    setRange("all");
    setStartDate("");
    setEndDate("");
    setSortBy("createdAt");
    setSortOrder("desc");
    setUsername("");
    currentPage.current = 1;
    setTimeout(() => getPaginatedUsers(), 0);
  }

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  const SortIcon = ({ field }) => {
    if (sortBy !== field) return <span className="text-muted ml-1">↕</span>;
    return <span className="ml-1">{sortOrder === "asc" ? "↑" : "↓"}</span>;
  };

  function toggleSort(field) {
    if (sortBy === field) {
      setSortOrder(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("desc");
    }
  }

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a { border-radius: 7px; padding: 0.1rem 1rem; border: gray 1px solid; cursor: pointer; margin: 0 5px; }
    li.previous a, li.next a, li.break a { border-color: transparent; }
    li.active a { background-color: #0366d6; border-color: transparent; color: white; min-width: 32px; }
    li.disabled a { color: grey; }
    li.disable, li.disabled a { cursor: default; }
  `;

  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

            {/* Summary Cards */}
            <div className="row mb-1">
              <div className="col-md-4">
                <div className="card text-white bg-primary">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="card-title mb-1">Total Users</h6>
                      <h3 className="mb-0">{summary.totalUser}</h3>
                    </div>
                    <i className="fa fa-list fa-2x opacity-75"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card text-white bg-warning">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="card-title mb-1">Total Bet Amount</h6>
                      <h3 className="mb-0">৳{summary.totalBetAmount?.toLocaleString()}</h3>
                    </div>
                    <i className="fa fa-coins fa-2x opacity-75"></i>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card text-white bg-success">
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="card-title mb-1">Total Rebate Bonus</h6>
                      <h3 className="mb-0">৳{summary.totalRebateGiven?.toLocaleString()}</h3>
                    </div>
                    <i className="fa fa-gift fa-2x opacity-75"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Rebate Commission List</h4>
                <Link to="/rebate-distribute">
                  <button type="button" className="btn btn-success">
                    Distribute Rebate Commission
                  </button>
                </Link>
              </div>

              <div className="card-body">

                {/* ✅ Filter Bar */}
                <div className="row mb-1 align-items-end">

                  {/* Date Range Buttons */}
                  <div className="col-md-5">
                    <label className="d-block mb-1"><small>Date Range</small></label>
                    <div className="btn-group">
                      {["all", "daily", "weekly", "monthly", "custom"].map(r => (
                        <button
                          key={r}
                          className={`btn btn-sm ${range === r ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setRange(r)}
                        >
                          {r.charAt(0).toUpperCase() + r.slice(1)}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Custom Date Inputs */}
                  {range === "custom" && (
                    <div className="col-md-4">
                      <label className="d-block mb-1"><small>Custom Range</small></label>
                      <div className="d-flex gap-2">
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={startDate}
                          onChange={e => setStartDate(e.target.value)}
                        />
                        <span className="align-self-center">→</span>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={endDate}
                          onChange={e => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                  )}

                  {/* Sort By */}
                  <div className="col-md-2">
                    <label className="d-block mb-1"><small>Sort By</small></label>
                    <select
                      className="form-control form-control-sm"
                      value={sortBy}
                      onChange={e => setSortBy(e.target.value)}
                    >
                      <option value="createdAt">Date</option>
                      <option value="amount">Rebate Amount</option>
                      <option value="totalAmount">Bet Amount</option>
                    </select>
                  </div>

          
                  {/* Username Search */}
                  <div className="col-md-3">
                    <label className="d-block mb-1"><small>Search Username</small></label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search username..."
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        onKeyDown={e => e.key === "Enter" && handleSearch()}
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" onClick={handleSearch}>Go</button>
                      </div>
                    </div>
                  </div>

                  {/* Reset */}
                  <div className="col-md-1 mt-2">
                    <button className="btn btn-danger" onClick={handleReset}>
                      Reset
                    </button>
                  </div>
                </div>
                {/* Table */}
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                      <tr>
                        <th>#</th>
                        <th>Username</th>
                        <th style={{ cursor: "pointer" }} onClick={() => toggleSort("totalAmount")}>
                          Total Bet <SortIcon field="totalAmount" />
                        </th>
                        <th style={{ cursor: "pointer" }} onClick={() => toggleSort("amount")}>
                          Rebate (0.5%) <SortIcon field="amount" />
                        </th>
                        <th style={{ cursor: "pointer" }} onClick={() => toggleSort("createdAt")}>
                          Date <SortIcon field="createdAt" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center text-muted py-4">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        data.map((element, id) => (
                          <tr key={element._id}>
                            <td>{(currentPage.current - 1) * limit + id + 1}</td>
                            <td>{element.username}</td>
                            <td>৳{parseFloat(element.totalAmount).toLocaleString()}</td>
                            <td>
                              <span className="badge badge-success">
                                ৳{parseFloat(element.amount).toFixed(2)}
                              </span>
                            </td>
                            <td>{formatDate(element.createdAt)}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PromoCodeList;